import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@seahorse/ui";

import { fetchInsights, setSessionVariable } from "../Utils/CoTraderUtils";

import { CircularProgress } from "@seahorse/ui";
import PriceChartTileComponent from "../Components/CoTraderPriceChartTileComponent";
import PopOverMenu from "../../PopOverMenu";
interface Context {
  id?: {
    [key: string]: string;
  };
  name?: string;
  type: string;
  [s: string]: any;
}
interface ContextProp {
  context: Context;
  currencyList: string[];
}
const CoTraderInsightTile: React.FunctionComponent<ContextProp> = ({
  context,
  currencyList,
}) => {
  const theme = useTheme();
  const colors = {
    dark: theme.globallink.colors.Black[100],
    background: theme.globallink.colors.Grey[1100], // Dark background for the entire tile
    containerBackground: theme.globallink.colors.DarkGrey[500], // Slightly lighter background for each insight box
    titleBackground: theme.globallink.colors.White[500], // Background color for the title bar
    textPrimary: theme.globallink.colors.Blue[500], // Primary text color (white)
    textSecondary: theme.globallink.colors.Grey[600], // Secondary text color (light grey)
    border: theme.globallink.colors.Slate[700], // Border color (slightly darker grey)
  };

  const useStyles = makeStyles({
    container: {
      width: "100%", // Updated width
      height: "100%", // Updated height
      backgroundColor: theme.globallink.colors.DarkGrey[500],
      padding: "10px",
      color: "white",
      display: "flex",
      flexDirection: "column", // Use column layout
    },
    sectionTitle: {
      color: colors.titleBackground,
    },
    title: {
      color: "#E0E0E0",
      fontSize: "16px",
      fontWeight: "bolder",
      display: "flex",
      justifyContent: "space-between",
      padding: "4px",
      alignItems: "center", // Align items vertically in the center
    },
    price: {
      fontSize: "20px",
    },
    insightSection: {
      marginTop: "10px",
    },
    keySection: {
      marginTop: "10px", // Adjusted to fit new dimensions
    },
    content: {
      lineHeight: "1.6",
      overflow: "auto",
      paddingLeft: "8px",
    },
    keyTakeaway: {
      fontSize: "16px",
      fontWeight: "bold",
      marginTop: "20px",
    },
    bulletPoints: {
      fontSize: "12px",
      margin: "12px 0",
    },
    chartContainer: {
      height: "200px",
      "@media (max-height: 480px)": {
        display: "none", // Hide chart on small screens
      },
    },
    loadingContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    },
    popoverContainer: {
      display: "flex",
      justifyContent: "end",
      width: "100%",
    },
  });

  const classes = useStyles();
  const [insights, setInsights] = useState([]);
  const [takeaway, setTakeaway] = useState([]);
  const [currencyPair, setCurrencyPair] = useState("USDJPY");
  const [currentPrice, setCurrentPrice] = useState("");
  const [loading, setIsloading] = useState(true);
  const [useContext, setUseContext] = useState(true);
  const [updateSpeed, setUpdateSpeed] = useState(3);
  const [language, setLanguage] = useState(
    localStorage.getItem("user_language") || "English"
  );
  useEffect(() => {
    const updateInsights = () => {
      fetchInsights(
        setInsights,
        setTakeaway,
        setCurrencyPair,
        setCurrentPrice,
        setIsloading,
        currencyPair,
        language
      );
    };
    updateInsights();
    const intervalId = setInterval(() => {
      updateInsights();
    }, 10000);
    return () => clearInterval(intervalId);
  }, [currencyPair]);

  useEffect(() => {
    // Function to fetch and update chart data
    try {
      if (useContext) {
        if (context) {
          const currencyPairReceived = context.instruments[0].id.ticker;
          if (currencyList.includes(currencyPairReceived)) {
            setCurrencyPair(currencyPairReceived);
          }
          console.log("context Changed , Currency Pair Changed", currencyPair);
        } else {
          console.log("No Context Available");
        }
      }
    } catch {
      console.log("Some Error Happened");
    }
    setSessionVariable(currencyPair);
  }, [context]);
  useEffect(() => {
    setSessionVariable(currencyPair);
  }, [currencyPair]);

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <div>{currencyPair}</div>

        <div>
          {" "}
          <PopOverMenu
            currencyPair={currencyPair}
            setCurrencyPair={setCurrencyPair}
            setUpdateSpeed={setUpdateSpeed}
            setUseContext={setUseContext}
            showUpdateSpeed={false}
            currencyList={currencyList}
            tenorList={null}
            setTenor={null}
            setUserLanguage={setLanguage}
            userLanguage={language}
          />
        </div>
      </div>
      <>
        <div className={classes.chartContainer}>
          <PriceChartTileComponent
            currencyPair={currencyPair}
            setCurrentPrice={() => {}}
          />
        </div>
      </>
      {loading ? (
        <>
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          <>
            <div className={classes.insightSection}>
              <div className={classes.sectionTitle}>Insight</div>
              <div className={classes.content}>
                {insights.map((insight, index) => (
                  <p key={index} className={classes.bulletPoints}>
                    • {insight}
                  </p>
                ))}
              </div>
            </div>
            <div className={classes.keySection}>
              <div className={classes.sectionTitle}>Key Take Away</div>
              <div className={classes.content}>
                {takeaway.map((takeaway, index) => (
                  <p key={index} className={classes.bulletPoints}>
                    • {takeaway}
                  </p>
                ))}
              </div>
            </div>
          </>
        </>
      )}
    </div>
  );
};

export default CoTraderInsightTile;
